import { demoFile, feature } from 'system/demo';
import { ReplyPushNotificationsFeature } from '../reply-push-notifs';
import { SimpleCommentsStructure } from 'structure/simple-comments';

demoFile('open-modules/zdf/feature/pushNotifications/reply-push-notifs');

feature('Reply Push Notifications', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    features: { replypushnotifications: true },
    state: { collections: { comment: [{key: 'c1', from: 'u', text: 'T', replyTo: 'p1'}] } }
});
